import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer section" }
const _hoisted_3 = { class: "footer paragraph" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "mailto:info@invested.fi",
  class: "a mail-to-invested-info",
  "aria-label": "info@invested.fi"
}, " info@invested.fi ", -1)
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "footer section" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("section", { id: "copyrights" }, [
  /*#__PURE__*/_createElementVNode("p", { id: "playstore" }, " Google Play and the Google Play logo are trademarks of Google LLC. "),
  /*#__PURE__*/_createElementVNode("p", { id: "testflight" }, "Appstore is a trademark of Apple Inc.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_router_link, {
          class: _normalizeClass(["a to-teachers-guide", { selected: _ctx.$route.path === '/teachers' }]),
          to: "/teachers"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('teachers-guide')), 1)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["a to-privacy-policy", { selected: _ctx.$route.path === '/privacy' }]),
          to: "/privacy"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('privacy')), 1)
          ]),
          _: 1
        }, 8, ["class"]),
        _createElementVNode("img", {
          class: "logo footer",
          src: _ctx.logo
        }, null, 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("img", {
        id: "eu_leverage",
        src: _ctx.leverage_eu
      }, null, 8, _hoisted_7)
    ]),
    _hoisted_8
  ]))
}